import { ChevronRight } from "lucide-mui"
import React from "react"

import i18n from "@/i18n"
import Logo from "@/pages/public/logo"

type SheetSubmitBarProps = {
  disabled: boolean
  onSubmit: () => void
}

const SheetSubmitBar: React.FC<SheetSubmitBarProps> = ({ disabled, onSubmit }) => (
  <div className="shrink-0 border-t border-[#eaeaea] bg-white px-5 pb-2 pt-4">
    <button
      type="button"
      onClick={onSubmit}
      disabled={disabled}
      className="relative flex h-[50px] w-full items-center justify-center rounded-[6px] border text-[14px] font-medium text-white transition-opacity disabled:opacity-40"
      style={{ backgroundImage: "linear-gradient(180deg, #2596FA 3%, #165994 100%)", borderColor: "#3478B7" }}
      data-testid="public-venue-mobile-booking-submit"
    >
      <span>{i18n.t("app.public.venue.mobile_booking.submit")}</span>
      <ChevronRight className="absolute right-4 h-5 w-5" />
    </button>

    <div className="flex justify-center py-[10px]">
      <Logo variant="wordmark" className="h-[10px] w-auto" aria-label="tabb" />
    </div>
  </div>
)

export default SheetSubmitBar
